import React, { useState, useEffect } from "react";
import { db, storage } from "../firebase";

import {
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

const Question = () => {
  const [formData, setFormData] = useState({
    qno: "",
    q: "",
    qimg: "",

    a: "",
    b: "",
    c: "",
    d: "",

    imgop1: "",
    imgop2: "",
    imgop3: "",
    imgop4: "",

    ans: "",

    // Explanation audio
    ansaudio: "",

    // Maths solution image
    solutionimg: "",

    testid: String(localStorage.getItem("testid") || ""),
  });

  const [uploading, setUploading] = useState({
    qimg: false,

    imgop1: false,
    imgop2: false,
    imgop3: false,
    imgop4: false,

    ansaudio: false,

    solutionimg: false,
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  // Fetch testid from localStorage
  useEffect(() => {
    const savedTestId = localStorage.getItem("testid");

    if (savedTestId) {
      setFormData((prev) => ({
        ...prev,
        testid: savedTestId,
      }));
    }
  }, []);

  // Handle text input changes
  const handleTextChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Save test ID
    if (name === "testid") {
      localStorage.setItem("testid", value);
    }
  };

  // Generic Firebase Storage file upload handler
  const handleFileUpload = async (e, fieldName, storagePath) => {
    const file = e.target.files[0];

    if (!file || !formData.testid) {
      return;
    }

    setUploading((prev) => ({
      ...prev,
      [fieldName]: true,
    }));

    try {
      const fileRef = ref(
        storage,
        `questions/${formData.testid}/${storagePath}/${Date.now()}_${file.name}`
      );

      const uploadTask = uploadBytesResumable(fileRef, file);

      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",

          null,

          (error) => {
            reject(error);
          },

          async () => {
            const downloadURL = await getDownloadURL(
              uploadTask.snapshot.ref
            );

            setFormData((prev) => ({
              ...prev,
              [fieldName]: downloadURL,
            }));

            resolve();
          }
        );
      });
    } catch (err) {
      console.error(`Error uploading ${fieldName}:`, err);

      setError(`Failed to upload ${fieldName}. Please try again.`);
    } finally {
      setUploading((prev) => ({
        ...prev,
        [fieldName]: false,
      }));
    }
  };

  // Submit question
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      if (!formData.testid) {
        throw new Error(
          "Test ID is required. Please set it in localStorage."
        );
      }

      if (!formData.qno || !formData.q || !formData.ans) {
        throw new Error("Please fill all required fields.");
      }

      const questionData = {
        ...formData,

        qno: parseInt(formData.qno),

        createdAt: serverTimestamp(),
      };

      // Save question to Firestore
      await addDoc(
        collection(db, "mocktest"),
        questionData
      );

      setSuccess(true);

      // Reset form except test ID
      setFormData({
        qno: "",

        q: "",

        qimg: "",

        a: "",
        b: "",
        c: "",
        d: "",

        imgop1: "",
        imgop2: "",
        imgop3: "",
        imgop4: "",

        ans: "",

        ansaudio: "",

        solutionimg: "",

        testid: formData.testid,
      });
    } catch (err) {
      console.error("Error saving question:", err);

      setError(err.message || "Failed to save question.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(to bottom right, #f9fafb, #f3f4f6)",
        paddingBottom: "60px",
      }}
    >
      {/* Header */}

      <div
        style={{
          backgroundColor: "white",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          borderBottom: "1px solid #f3f4f6",
          padding: "32px 24px",
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          <h1
            style={{
              fontSize: "2.1rem",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            Add New Question
          </h1>

          <p
            style={{
              color: "#6b7280",
              marginTop: "8px",
            }}
          >
            Upload images & audio to Firebase Storage • Save to mocktest
            collection
          </p>
        </div>
      </div>

      {/* Main Container */}

      <div
        style={{
          maxWidth: "1000px",
          margin: "40px auto",
          padding: "0 24px",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "24px",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
            padding: "40px",
            border: "1px solid #f3f4f6",
          }}
        >
          <form onSubmit={handleSubmit}>

            {/* Question Number & Test ID */}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "28px",
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Question Number *
                </label>

                <input
                  type="number"
                  name="qno"
                  value={formData.qno}
                  onChange={handleTextChange}
                  required
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    borderRadius: "12px",
                    border: "1px solid #d1d5db",
                  }}
                />
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Test ID
                </label>

                <input
                  type="text"
                  name="testid"
                  value={formData.testid || ""}
                  onChange={handleTextChange}
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    borderRadius: "12px",
                    border: "1px solid #d1d5db",
                    backgroundColor: "#f9fafb",
                  }}
                />
              </div>
            </div>

            {/* Question Text */}

            <div
              style={{
                marginTop: "28px",
              }}
            >
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Question Text *
              </label>

              <textarea
                name="q"
                value={formData.q}
                onChange={handleTextChange}
                required
                rows="4"
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  borderRadius: "12px",
                  border: "1px solid #d1d5db",
                  resize: "vertical",
                }}
                placeholder="Enter the full question..."
              />
            </div>

            {/* Question Image */}

            <div
              style={{
                marginTop: "28px",
              }}
            >
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Question Image
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  handleFileUpload(e, "qimg", "qimg")
                }
                style={{
                  marginBottom: "8px",
                }}
              />

              {uploading.qimg && (
                <p
                  style={{
                    color: "#3b82f6",
                  }}
                >
                  Uploading question image...
                </p>
              )}

              {formData.qimg && (
                <div
                  style={{
                    marginTop: "8px",
                  }}
                >
                  <img
                    src={formData.qimg}
                    alt="Question"
                    style={{
                      maxWidth: "200px",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
            </div>

            {/* Options */}

            <h3
              style={{
                margin: "36px 0 20px",
                color: "#1f2937",
              }}
            >
              Options (A, B, C, D)
            </h3>

            {["a", "b", "c", "d"].map((opt, idx) => {
              const imgField = `imgop${idx + 1}`;

              return (
                <div
                  key={opt}
                  style={{
                    marginBottom: "28px",
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Option {opt.toUpperCase()} *
                  </label>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "16px",
                    }}
                  >
                    <input
                      type="text"
                      name={opt}
                      value={formData[opt]}
                      onChange={handleTextChange}
                      required
                      placeholder={`Option ${opt.toUpperCase()} text`}
                      style={{
                        padding: "14px 16px",
                        borderRadius: "12px",
                        border: "1px solid #d1d5db",
                      }}
                    />

                    <div>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleFileUpload(
                            e,
                            imgField,
                            `options/${opt}`
                          )
                        }
                      />

                      {uploading[imgField] && (
                        <p
                          style={{
                            color: "#3b82f6",
                            fontSize: "0.9rem",
                          }}
                        >
                          Uploading...
                        </p>
                      )}

                      {formData[imgField] && (
                        <img
                          src={formData[imgField]}
                          alt={`Option ${opt}`}
                          style={{
                            maxWidth: "120px",
                            marginTop: "8px",
                            borderRadius: "6px",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Correct Answer */}

            <div
              style={{
                marginTop: "28px",
              }}
            >
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Correct Answer *
              </label>

              <select
                name="ans"
                value={formData.ans}
                onChange={handleTextChange}
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  borderRadius: "12px",
                  border: "1px solid #d1d5db",
                }}
              >
                <option value="">
                  Select correct option
                </option>

                <option value="a">A</option>
                <option value="b">B</option>
                <option value="c">C</option>
                <option value="d">D</option>
              </select>
            </div>

            {/* SOLUTION IMAGE - ONLY FOR MATHS */}

            {formData.testid
              .toLowerCase()
              .startsWith("m") && (
              <div
                style={{
                  marginTop: "28px",
                }}
              >
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Solution Image
                </label>

                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      "solutionimg",
                      "solution-image"
                    )
                  }
                />

                {uploading.solutionimg && (
                  <p
                    style={{
                      color: "#3b82f6",
                    }}
                  >
                    Uploading solution image...
                  </p>
                )}

                {formData.solutionimg && (
                  <div
                    style={{
                      marginTop: "12px",
                    }}
                  >
                    <img
                      src={formData.solutionimg}
                      alt="Solution"
                      style={{
                        maxWidth: "300px",
                        borderRadius: "8px",
                        border: "1px solid #e5e7eb",
                      }}
                    />

                    <p
                      style={{
                        marginTop: "8px",
                        color: "#10b981",
                      }}
                    >
                      ✓ Solution image uploaded successfully
                    </p>
                  </div>
                )}
              </div>
            )}

            {/* EXPLANATION AUDIO - FOR ALL QUESTIONS */}

            <div
              style={{
                marginTop: "28px",
              }}
            >
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Answer Explanation Audio
              </label>

              <input
                type="file"
                accept="audio/*"
                onChange={(e) =>
                  handleFileUpload(
                    e,
                    "ansaudio",
                    "audio"
                  )
                }
              />

              {uploading.ansaudio && (
                <p
                  style={{
                    color: "#3b82f6",
                  }}
                >
                  Uploading audio...
                </p>
              )}

              {formData.ansaudio && (
                <p
                  style={{
                    marginTop: "8px",
                    color: "#10b981",
                  }}
                >
                  ✓ Audio uploaded successfully
                </p>
              )}
            </div>

            {/* Submit Button */}

            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: "40px",
                width: "100%",
                padding: "16px",
                backgroundColor: loading
                  ? "#9ca3af"
                  : "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "16px",
                fontSize: "1.1rem",
                fontWeight: "600",
                cursor: loading
                  ? "not-allowed"
                  : "pointer",
              }}
            >
              {loading
                ? "Saving Question..."
                : "Save Question to mocktest Collection"}
            </button>
          </form>

          {/* Success Message */}

          {success && (
            <div
              style={{
                marginTop: "24px",
                padding: "16px",
                backgroundColor: "#ecfdf5",
                color: "#10b981",
                borderRadius: "12px",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              ✅ Question uploaded successfully to Firestore
              (mocktest collection)!
            </div>
          )}

          {/* Error Message */}

          {error && (
            <div
              style={{
                marginTop: "24px",
                padding: "16px",
                backgroundColor: "#fef2f2",
                color: "#ef4444",
                borderRadius: "12px",
                textAlign: "center",
              }}
            >
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Question;